/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Import_Phase_SavingInputs */

const en_ui_import_phase_saving = /** @type {(inputs: Ui_Import_Phase_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const de_ui_import_phase_saving = /** @type {(inputs: Ui_Import_Phase_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Ui_Import_Phase_SavingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_phase_saving = /** @type {((inputs?: Ui_Import_Phase_SavingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Phase_SavingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_phase_saving(inputs)
	return de_ui_import_phase_saving(inputs)
});